import React from 'react';

import { QuietZoneCalculator } from '../../Insulation/QuietZoneCalculator';

// eslint-disable-next-line react/prop-types
const CMSQuietZoneCalculator = ({ footnotes }) => <QuietZoneCalculator footnotes={footnotes} />;

export default CMSQuietZoneCalculator;
